/* import __COLOCATED_TEMPLATE__ from './tasks-popup.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();